import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import ReportedListingsDisplay from '../components/ReportedListingsDisplay';
import ReportedListingDetails from '../components/ReportedListingDetails';

const ReportedListings = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedListing, setSelectedListing] = useState(null);
    const [statusFilter, setStatusFilter] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [refreshKey, setRefreshKey] = useState(0);

    const toggleCanvas = () => {
        setIsOpen(!isOpen);
    };

    const handleStatusFilterChange = (event) => {
        setStatusFilter(event.target.value);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleListingClick = (listing) => {
        setSelectedListing(listing);
        setIsOpen(true);
    };

    const handleRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    return (
        <div className='d-flex w-100 overflow-hidden'>
            <div className='asidebar'>
                <Sidebar />
            </div>
            <div className='main-content'>
                <div className='d-flex align-items-center justify-content-between mb-4'>
                    <h2>Reported Listings</h2>
                    <div className='d-flex align-items-center justify-content-end'>
                        <div className="me-3">
                            <input
                                type="text"
                                className="form-control w-300px rounded-50 ps-3" 
                                style={{height: '50px'}}
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div className="">
                            <select
                                className="form-control rounded-50 ps-3" 
                                style={{ height: '50px', minWidth: '150px' }}
                                value={statusFilter}
                                onChange={handleStatusFilterChange}
                            >
                                <option value="">All Statuses</option>
                                <option value="PENDING">Pending</option>
                                <option value="RESOLVED">Resolved</option>
                                <option value="DISMISSED">Dismissed</option>
                                <option value="REMOVED">Removed</option>
                            </select>
                        </div>
                    </div>
                </div>
                
                <ReportedListingsDisplay 
                    key={refreshKey}
                    statusFilter={statusFilter}
                    searchQuery={searchQuery}
                    onListingClick={handleListingClick}
                />
                
                <Offcanvas 
                    isOpen={isOpen} 
                    toggle={toggleCanvas} 
                    className="custom-canvas-width" 
                    direction='end'
                >
                    <OffcanvasHeader className='mb-4 mx-4 mt-2 border-bottom' toggle={toggleCanvas}>
                        <span className='font-weight-bold'>
                            {selectedListing?.listing?.title || 'Listing Details'}
                        </span>
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        {selectedListing && (
                            <ReportedListingDetails 
                                listing={selectedListing} 
                                onEject={() => {
                                    setIsOpen(false);
                                    handleRefresh();
                                }}
                            />
                        )}
                    </OffcanvasBody>
                </Offcanvas>
            </div>
        </div>
    );
};

export default ReportedListings;
